import { ThemeOptions } from 'theme/types';

export default {
  notificationsList: (theme: ThemeOptions) => ({
    bottom: 70,
    margin: 0,
    left: '50%',
    zIndex: 3000,
    width: '100%',
    maxWidth: 320,
    position: 'fixed',
    transform: 'translate(-50%, 0)',
    [theme.breakpoints.up('md')]: {
      top: 15,
      bottom: 'inherit',
      maxWidth: 400,
    },
  }),
};
